import mockDataGenerator from '../mock/mockDataGenerator';

// Toggle to switch between mock and real API
const USE_MOCK_DATA = true;

class DashboardService {
  // Sales endpoints
  async getSalesMetrics(restaurantId, dateRange) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateSalesMetrics(restaurantId, dateRange)
      };
    }
    
    // TODO: Replace with real API call
    // const response = await fetch(`${API_URL}/analytics/sales?restaurantId=${restaurantId}`);
    // return await response.json();
  }

  async getHourlySales(restaurantId, date) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateHourlySales(date)
      };
    }
  }

  async getTopItems(restaurantId, limit = 10, period = 'week') {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateTopItems(limit, period)
      };
    }
  }

  async getBottomItems(restaurantId, limit = 5) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateBottomItems(limit)
      };
    }
  }

  async getSalesByChannel(restaurantId) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateSalesByChannel()
      };
    }
  }

  // Cost endpoints
  async getCostMetrics(restaurantId, dateRange) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateCostMetrics(dateRange)
      };
    }
  }

  async getCostTrend(restaurantId, days = 14) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateCostTrend(days)
      };
    }
  }

  async getWasteData(restaurantId) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateWasteData()
      };
    }
  }

  // Operational endpoints
  async getOperationalMetrics(restaurantId) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateOperationalMetrics()
      };
    }
  }

  async getServiceTimeTrend(restaurantId, days = 7) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateServiceTimeTrend(days)
      };
    }
  }

  // Staff endpoints
  async getWaiterStats(restaurantId) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateWaiterStats()
      };
    }
  }

  async getChefStats(restaurantId) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateChefStats()
      };
    }
  }

  async getStaffScheduleCompliance(restaurantId) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateStaffScheduleCompliance()
      };
    }
  }

  // Customer endpoints
  async getCustomerMetrics(restaurantId) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateCustomerMetrics()
      };
    }
  }

  async getCustomerTrafficHeatmap(restaurantId) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateCustomerTrafficHeatmap()
      };
    }
  }

  async getReviewsTrend(restaurantId, days = 30) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateReviewsTrend(days)
      };
    }
  }

  // Dashboard summary
  async getDashboardSummary(restaurantId) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateDashboardSummary(restaurantId)
      };
    }
  }

  // Experiments
  async getExperiments(restaurantId) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateExperiments()
      };
    }
  }

  // Alerts
  async getAlerts(restaurantId) {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateAlerts()
      };
    }
  }

  // Multi-restaurant (admin)
  async getRestaurantComparison() {
    if (USE_MOCK_DATA) {
      return {
        success: true,
        data: mockDataGenerator.generateRestaurantComparison()
      };
    }
  }

  // Get all restaurants
  async getRestaurants() {
    if (USE_MOCK_DATA) {
      // Import RESTAURANTS from the mock data generator
      const { RESTAURANTS } = await import('../mock/mockDataGenerator');
      return {
        success: true,
        data: RESTAURANTS
      };
    }
  }
}

export default new DashboardService();

